module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.payment.total_including_gst
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-3"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('invoice_number')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Invoice Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.number),
      expression: "number"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "invoice_number",
      "placeholder": "Invoice Number",
      "disabled": _vm.cannotEditInvoice
    },
    domProps: {
      "value": (_vm.number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.number = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-sm-6 col-md-8': _vm.canEditInvoice, 'col-sm-12': _vm.cannotEditInvoice
    }
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('invoice_file')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Invoice File (Maximum 3MB)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "invoice_file",
      "type": "text",
      "placeholder": "Invoice File",
      "disabled": ""
    },
    domProps: {
      "value": _vm.file
    }
  })])])]), _vm._v(" "), (_vm.canEditInvoice) ? _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm btn-block m-b-md",
    attrs: {
      "for": "invoice_file"
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "invoice_file",
      "accept": ".jpg,.jpeg,.png,.gif,.pdf",
      "disabled": _vm.cannotEditInvoice
    },
    on: {
      "change": _vm.handleFileSelection
    }
  }), _vm._v("\n              Select File\n            ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.canEditInvoice) ? _c('div', {
    staticClass: "ibox-footer text-right"
  }, [_c('ladda-button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "on-click": _vm.handleUploadInvoice
    }
  }, [_vm._v("Save")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v("Upload Invoice")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-8477b2e2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/ShowUploadInvoice.vue
// module id = 1060
// module chunks = 0